import { type FC } from "react"

import { type UserCoursePageInput } from "@forento/shared/models/course"
import { toRelativeDateString } from "@forento/shared/utilities/date"

import { useLocale, useTranslation } from "~/translations"

const Inputs: FC<{ inputs: UserCoursePageInput[] }> = ({ inputs }) => {
	const t = useTranslation()
	const locale = useLocale()

	return (
		<div className="flex flex-col gap-6">
			{inputs.map(input => (
				<div key={input.id} className="space-y-4 rounded-2xl border border-gray-200 bg-gray-100 px-6 py-4">
					<div className="flex flex-col gap-4">
						<h3 className="font-quicksand text-xl font-bold">{input.title}</h3>
						<div className="flex flex-wrap items-center gap-4">
							<div className="rounded-full bg-linear-120 from-primary to-primary/80 px-3 py-1.5 text-sm font-medium text-white shadow-md">
								{input.chapter.title}
							</div>
							<div className="text-sm font-medium text-light">
								{toRelativeDateString(input.createDate, locale)}
							</div>
						</div>
					</div>

					<p className="whitespace-pre-wrap text-light">{input.text}</p>

					{input.inputs.length > 1 && (
						<div className="border-t border-t-gray-200 pt-4">
							<h4 className="mb-4 font-quicksand font-medium">
								{t("course.previousResponses", { count: input.inputs.length - 1 })}
							</h4>
							<div className="flex flex-col gap-4">
								{input.inputs.slice(1).map(revision => (
									<div key={revision.id} className="rounded-xl border border-gray-200 bg-white p-4">
										<p className="mb-3 text-sm whitespace-pre-wrap text-light">{revision.text}</p>
										<div className="text-xs font-medium text-light">
											{toRelativeDateString(revision.createDate, locale)}
										</div>
									</div>
								))}
							</div>
						</div>
					)}
				</div>
			))}
		</div>
	)
}

export default Inputs
